import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { isArrayNotEmpty, getObjectPropertyValue, isNumberValid } from 'functions';
import React, { useEffect, useState } from 'react';
import useDebitNoteV2 from 'dataflow/billingPortal/actions/useDebitNoteV2.actions';
import { useCustomSelector } from 'hooks';

export function useDeleteDebitNote({
    selectedDebitNotes
}) {

    const [isModalVisible, setIsModalVisible] = useState(false);

    let { 
        deleteDebitNote_requesting
    } = useCustomSelector("debitNoteV2");

    const { deleteDebitNote } = useDebitNoteV2();

    function handleDeleteDebitNote() {
        if (isArrayNotEmpty(selectedDebitNotes)) {
            selectedDebitNotes.map((debitNoteDetails) => { 
                let id = getObjectPropertyValue(debitNoteDetails, "Id");
    
                if (isNumberValid(id)) {
                    deleteDebitNote(id)
                }
            });
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 account.",
            });
        }
    }

    let deleteModalDisplay = (
        <ConfirmationModal
            description={"The selected debit note(s) will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={handleDeleteDebitNote}
            isActionLoading={deleteDebitNote_requesting}
        />
    );
    
    return {
        deleteModalDisplay,
        setIsModalVisible
    }
}